var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavUp = function SvgNavUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.97,
    height: 16.97,
    viewBox: "0 0 16.97 16.97"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4cc0ad",
    d: "m9.192.707 7.071 7.07a1 1 0 1 1-1.414 1.415L8.485 2.828 2.121 9.192A1 1 0 1 1 .707 7.778L7.777.707a1 1 0 0 1 1.415 0",
    "data-name": "Union 16"
  })));
};
export default SvgNavUp;